/**
 * @generated SignedSource<<3b737851a5ecbd14cbabcc2b13cf96b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SudoDeleteEverything_viewer$data = {
  readonly id: string;
  readonly " $fragmentType": "SudoDeleteEverything_viewer";
};
export type SudoDeleteEverything_viewer$key = {
  readonly " $data"?: SudoDeleteEverything_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SudoDeleteEverything_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SudoDeleteEverything_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "978d6fa2f42feeff3804299a9c099b8b";

export default node;
